import React, { useEffect, useState } from "react";
import { saasApi } from "../../api/saasApi";

export default function CompanyManagement() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    saasApi.adminCompanies("?limit=50")
      .then((res) => setItems(res.data?.items || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const toggle = async (id, action) => {
    if (action === "suspend") await saasApi.suspendCompany(id);
    else await saasApi.activateCompany(id);
    load();
  };

  return (
    <div>
      <h1>SaaS Companies</h1>
      {loading ? <p>Loading…</p> : (
        <table className="saas-compare-table">
          <thead>
            <tr><th>Company</th><th>Main ID</th><th>Status</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id}>
                <td>{c.company_name}</td>
                <td>{c.main_id}</td>
                <td>{c.status}</td>
                <td>
                  {c.status === "suspended" ? (
                    <button type="button" className="saas-btn saas-btn--secondary" onClick={() => toggle(c.id, "activate")}>Activate</button>
                  ) : (
                    <button type="button" className="saas-btn saas-btn--secondary" onClick={() => toggle(c.id, "suspend")}>Suspend</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
